/**
 * Shifts
 */
export const shifts = {
  INIT: 'INIT_SHIFTS',
  SET: 'SET_SHIFT',
  SET_SHIFTS: 'SET_SHIFTS'
};

/**
 * 
 */

/**
 * Templates
 */
export const templates = {
  INIT: 'INIT_TEMPLATES',
  SET: 'SET_TEMPLATE',
  DELETE: 'DELETE_TEMPLATE'
}

/**
 * Auth
 */
export const auth = {
  AUTH_LOADING: 'AUTH_LOADING',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_ERROR: 'AUTH_ERROR',
  AUTH_NEW_PASSWORD: 'AUTH_NEW_PASSWORD'
};

/**
 * Navigation
 */
export const SET_NAVIGATION_STATE = 'SET_NAVIGATION_STATE';

/**
 * App
 */
export const app = {
  RESET: 'RESET_APP',
  SET_GLOBAL_ERROR: 'SET_GLOBAL_ERROR',
  SET_GLOBAL_LOADING: 'SET_GLOBAL_LOADING',
  SET_APP_STATE: 'SET_APP_STATE',
  SET_NETWORK_CONNECTION: 'SET_NETWORK_CONNECTION',
  SET_BUGSNAG_CLIENT: 'SET_BUGSNAG_CLIENT',
  SET_RESYNC_TIMESTAMP: 'SET_RESYNC_TIMESTAMP'
};

/**
 * Pending Mutations
 */
export const pendingMutations = {
  SET: 'SET_PENDING_MUTATIONS',
  ON_START: 'ON_PENDING_MUTATION_START',
  ON_SUCCESS: 'ON_PENDING_MUTATION_SUCCESS',
  ON_FAILURE: 'ON_PENDING_MUTATION_FAILURE'
};

/**
 * Geolocation
 */
export const geolocation = {
  SET_ACTIVE: 'SET_ACTIVE',
  SET_COORDS: 'SET_COORDS'
};

/**
 * SelectedProperty
 */
export const RECENT_PATROLS_SET = 'RECENT_PATROLS_SET';
export const RECENT_PATROLS_ERROR = 'RECENT_PATROLS_ERROR';
export const RECENT_PATROLS_SUCCESS = 'RECENT_PATROLS_SUCCESS';
export const RECENT_PATROLS_LOADING = 'RECENT_PATROLS_LOADING';
export const SWITCH_PATROL_VIEW_MODE = 'SWITCH_PATROL_VIEW_MODE';
export const ADD_PATROL = 'ADD_PATROL';


/**
 * Map
 */
export const map = {
  DIRECTIONS_LOADING: 'DIRECTIONS_LOADING',
  GET_DIRECTIONS_SUCCESS: 'GET_DIRECTIONS_SUCCESS',
  GET_DIRECTIONS_ERROR: 'GET_DIRECTIONS_ERROR',
  DIRECTIONS_REMOVE_POLYLINE: 'DIRECTIONS_REMOVE_POLYLINE',
  SET_SELECTED_MARKER: 'SET_SELECTED_MARKER',
  SET_MAP: 'SET_MAP',
  CLEAR_SELECTED_MARKER: 'CLEAR_SELECTED_MARKER'
}

/**
 * Filter
 */
export const filter = {
  SET: 'SET_FILTER',
  SET_MEDIUM_PRIORITY_ONLY: 'SET_MEDIUM_PRIORITY_ONLY'
}

/**
 * Properties
 */
export const SET_SELECTED_PROPERTY = 'SET_SELECTED_PROPERTY';
export const SET_SELECTED_INSTANCE = 'SET_SELECTED_INSTANCE';
export const SET_PROPERTY = 'SET_PROPERTY';
export const SET_PROPERTIES = 'SET_PROPERTIES';
export const SET_INSTANCE_LAST_VISITED = 'SET_INSTANCE_LAST_VISITED';
export const RESOLVE_INSTANCE_LOADING = 'RESOLVE_INSTANCE_LOADING';
export const RESOLVE_INSTANCE_SUCCESS = 'RESOLVE_INSTANCE_SUCCESS';
export const RESOLVE_INSTANCE_ERROR = 'RESOLVE_INSTANCE_ERROR';
export const SET_PROPERTY_EVENT = 'SET_PROPERTY_EVENT';
export const SET_PROPERTY_EVENTS = 'SET_PROPERTY_EVENTS';
export const SET_FILTER = 'SET_FILTER';
export const UPDATE_PROPERTY_LOADING = 'UPDATE_PROPERTY_LOADING';
export const UPDATE_PROPERTY_SUCCESS = 'UPDATE_PROPERTY_SUCCESS';
export const UPDATE_PROPERTY_ERROR = 'UPDATE_PROPERTY_ERROR';
export const properties = {
  CLEAR_INCIDENT_REPORTS: 'CLEAR_INCIDENT_REPORTS',
  GET_PENDING_INCIDENT_REPORTS_LOADING: 'GET_PENDING_INCIDENT_REPORTS_LOADING',
  GET_PENDING_INCIDENT_REPORTS_SUCCESS: 'GET_PENDING_INCIDENT_REPORTS_SUCCESS',
  GET_PENDING_INCIDENT_REPORTS_ERROR: 'GET_PENDING_INCIDENT_REPORTS_ERROR',
  UPDATE_INCIDENT_REPORT_LOADING: 'UPDATE_INCIDENT_REPORT_LOADING',
  UPDATE_INCIDENT_REPORT_SUCCESS: 'UPDATE_INCIDENT_REPORT_SUCCESS',
  UPDATE_INCIDENT_REPORT_ERROR: 'UPDATE_INCIDENT_REPORT_ERROR'
};

/**
 * Property Events
 */
export const FETCH_PROPERTY_EVENTS_REQUEST = 'FETCH_PROPERTY_EVENTS_REQUEST';
export const FETCH_PROPERTY_EVENTS_SUCCESS = 'FETCH_PROPERTY_EVENTS_SUCCESS';
export const FETCH_PROPERTY_EVENTS_FAILURE = 'FETCH_PROPERTY_EVENTS_FAILURE';

/**
 * Service Provider Users
 */
export const SET_USER = 'SET_USER';
export const SET_USERS = 'SET_USERS';
export const UPDATE_USER_LOADING = 'SET_USER_LOADING';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'SET_USER_ERROR'; 

/**
 * Subscriptions
 */
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const CLEAR_SUBSCRIPTIONS = 'CLEAR_SUBSCRIPTIONS';

/**
 * Search
 */
export const SEARCH_INDEX_LOADING = 'SEARCH_INDEX_LOADING';
export const SEARCH_INDEX_SUCCESS = 'SEARCH_INDEX_SUCCESS';
export const SEARCH_INDEX_ERROR = 'SEARCH_INDEX_ERROR';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_ERROR = 'SEARCH_ERROR';
export const SEARCH_LOADING = 'SEARCH_LOADING';

/**
 * Edit Notes
 */
export const editNotes = {
  SELECT: 'SET_SELECTED_NOTES',
  SET: 'SET_PENDING_NOTES',
  DISCARD: 'DISCARD_PENDING_NOTES'
};

/**
 * Create Property Report
 */
export const OPEN_AND_START_REPORT = 'OPEN_AND_START_REPORT';
export const CLOSE_AND_END_REPORT = 'CLOSE_AND_END_REPORT';
export const SET_PENDING_REPORT_NOTE = 'SET_PENDING_REPORT_NOTE';
export const REPORT_SET_LOADING = 'REPORT_SET_LOADING';

export const timeline = {
  SET_PARAMS: 'TIMELINE_SET_PARAMS',
  SET_SELECTED_DATE: 'TIMELINE_SET_SELECTED_DATE',
  SET_VISIBLE_MONTH_AND_YEAR: 'TIMELINE_SET_VISIBLE_MONTH_AND_YEAR',
  GET_MONTH_ACTIVITY_LOADING: 'TIMELINE_GET_MONTH_ACTIVITY_LOADING',
  GET_MONTH_ACTIVITY_SUCCESS: 'TIMELINE_GET_MONTH_ACTIVITY_SUCCESS',
  GET_MONTH_ACTIVITY_ERROR: 'TIMELINE_GET_MONTH_ACTIVITY_ERROR',
  CLEAR: 'TIMELINE_CLEAR'
};

/**
 * Schedule
 */
export const schedule = {
  GET_SERVICE_PROVIDER_SHIFTS_LOADING: 'GET_SERVICE_PROVIDER_SHIFTS_LOADING',
  GET_SERVICE_PROVIDER_SHIFTS_SUCCESS: 'GET_SERVICE_PROVIDER_SHIFTS_SUCCESS',
  GET_SERVICE_PROVIDER_SHIFTS_ERROR: 'GET_SERVICE_PROVIDER_SHIFTS_ERROR',
  GET_USER_SHIFTS_LOADING: 'GET_USER_SHIFTS_LOADING',
  GET_USER_SHIFTS_SUCCESS: 'GET_USER_SHIFTS_SUCCESS',
  GET_USER_SHIFTS_ERROR: 'GET_USER_SHIFTS_ERROR',
  INSERT_SHIFT: 'INSERT_SHIFT',
  INSERT_SHIFTS: 'INSERT_SHIFTS',
  DELETE_SHIFT: 'DELETE_SHIFT'
};

/**
 * Divisions
 */
export const divisions = {
  SET_DIVISION: 'SET_DIVISION',
  SET_DIVISIONS: 'SET_DIVISIONS'
};

/**
 *
 */
export const dars = {
  SET_DAR: 'SET_DAR',
  SET_DARS: 'SET_DARS'
};